import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import { graphql, useStaticQuery, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import parser from "html-react-parser"

const MilleniumMember = () => {
  const staticData = useStaticQuery(graphql`
    query {
      wpPage(isFrontPage: { eq: true }) {
        aCFhome {
          maMembershipText
          maMembershipTitle
          membershipContent
          membershipContentTitle
          membershipLearnMoreLink {
            url
          }
        }
      }
    }
  `)

  const {
    maMembershipText,
    maMembershipTitle,
    membershipContent,
    membershipContentTitle,
    membershipLearnMoreLink,
  } = staticData?.wpPage?.aCFhome

  return (
    <div className="explore-mill-wrap">
      <div
        className="home-new-millennium-wrap"
        style={{
          background: `#021733  0 0 no-repeat`,
        }}
      >
        <Container>
          <Row>
            <Col md={5} className="text-center">
              <div className="about-article-heading">{maMembershipTitle}</div>
              <div className="hm-conent-sec">
                <p>{maMembershipText}</p>
              </div>
              <div className="hide-mobile-btn">
                <Link to={membershipLearnMoreLink.url} className="btn-new">
                  <span className="circle" aria-hidden="true">
                    <span className="icon arrow"></span>
                  </span>
                  <span className="button-text"> Learn More </span>
                </Link>
              </div>
            </Col>
            <Col md={1} className="m-col-1-hide">&nbsp;</Col>
            <Col md={6}>
              <div className="home-new-millen-rt-sec">
                <div className="title-font-size-36">
                  {membershipContentTitle && parser(membershipContentTitle)}
                </div>
                <div>{membershipContent && parser(membershipContent)}</div>
                <div className="show-mobile-btn">
                  <Link
                    to={membershipLearnMoreLink.url}
                    className="btn white-btn"
                  >
                    <StaticImage
                      src="../../../images/next-arrow.png"
                      width={18}
                      height={12}
                      className="mt-1 mx-1"
                      alt="Arrow Icon"
                    />
                    Learn More
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default MilleniumMember
